var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorRegistrationLandingSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 231,
    viewBox: "0 0 114 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10.0817 42.4944H0V0ZM34.3738 50.3387L15.4586 43.4569L39.4147 6.97812L34.3738 50.3387ZM39.1266 53.0819L74.0766 27.0463L54.5373 66.0756L39.1266 53.0819ZM58.0419 70.2625L99.761 57.75L68.0756 87.7319L58.0419 70.2625ZM69.9959 92.8812L113.491 95.4319L73.5005 112.757L69.9959 92.8812ZM61.1144 115.5H0V54.2369C33.7497 54.2369 61.1144 81.6681 61.1144 115.5Z",
    fill: "#FFF6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 231L10.0817 188.506H0V231ZM34.3738 180.661L15.4586 187.543L39.4147 224.022L34.3738 180.661ZM39.1266 177.918L74.0766 203.954L54.5373 164.924L39.1266 177.918ZM58.0419 160.738L99.761 173.25L68.0756 143.268L58.0419 160.738ZM69.9959 138.119L113.491 135.568L73.5005 118.243L69.9959 138.119ZM61.1144 115.5H0V176.763C33.7497 176.763 61.1144 149.332 61.1144 115.5Z",
    fill: "#FFF6E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorRegistrationLandingSun);
export default __webpack_public_path__ + "static/media/MentorRegistrationLandingSun.8acafd87c731c3cd0fa298e66735495d.svg";
export { ForwardRef as ReactComponent };